import React from 'react';
import { Control, Controller } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';
import MultiSelectOTA from '~/features/base/components/forms/ota/MultiselectOTA';
import { useFetchSparePartNumbersQuery } from '~/api/controlDevice/ControlDevice.api';
import MileageFormItem from '~/features/base/components/forms/MileageFormItem';
import { createVehicleSparePartNumberOptionsWithoutAll } from '~/features/base/constants/filterOptions';
import { FILTER_IDS } from '~/features/devices/constants/filterMenuConstants';
import HeartWrapper from '~/features/devices/components/deviceFilters/HeartWrapper';

interface OtherFiltersSectionProps {
    control: Control<any>;
}

const OtherFiltersSection: React.FC<OtherFiltersSectionProps> = ({ control }) => {

    const { data: sparePartNumbers } = useFetchSparePartNumbersQuery({});
    const vehicleSparePartNumberOptions = createVehicleSparePartNumberOptionsWithoutAll(sparePartNumbers)?.map(option => option.label) || [];


    return (
        <div>
            <h4><FormattedMessage id='intl-msg:others' defaultMessage='Others'/></h4>
            <hr/>
            <div id={FILTER_IDS.MILEAGE}>
                <HeartWrapper>
                    <Controller
                        name='minMileage'
                        control={control}
                        render={({ field: { value: minValue, onChange: onMinChange } }) => (
                            <Controller
                                name='maxMileage'
                                control={control}
                                render={({ field: { value: maxValue, onChange: onMaxChange } }) => (
                                    <MileageFormItem
                                        minMileage={minValue || 0}
                                        maxMileage={maxValue || 0}
                                        onMinMileageChange={onMinChange}
                                        onMaxMileageChange={onMaxChange}
                                    />
                                )}
                            />
                        )}
                    />
                </HeartWrapper>
            </div>
            <div id={FILTER_IDS.SPARE_PART_NUMBER}>
                {vehicleSparePartNumberOptions.length > 0 ? (
                    <HeartWrapper key={`spare-part-${vehicleSparePartNumberOptions.length}`}>
                        <Controller
                            name='vehicleManufacturerSparePartNumber'
                            control={control}
                            render={({ field: { value, onChange } }) => (
                                <MultiSelectOTA
                                    labelId='intl-msg:manufacturerSparePartNumber'
                                    options={vehicleSparePartNumberOptions}
                                    value={value}
                                    onChange={onChange}
                                />
                            )}
                        />
                    </HeartWrapper>
                ) : (
                    <Controller
                        name='vehicleManufacturerSparePartNumber'
                        control={control}
                        render={({ field: { value, onChange } }) => (
                            <MultiSelectOTA
                                labelId='intl-msg:manufacturerSparePartNumber'
                                options={vehicleSparePartNumberOptions}
                                value={value}
                                onChange={onChange}
                            />
                        )}
                    />
                )}
            </div>

        </div>
    );
};

export default OtherFiltersSection;
